import React, { FC } from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import Form from '~/components/WizardForm';
import Section from '~/layouts/Section ';
import CompanyInformationInputs from './components/CompanyInformationInputs';
import ExpectedTurnoverInputs from './components/ExpectedTurnoverInputs';
import CustomFields from '~/components/CustomFields';
import DeclarationInputs from './components/DeclarationInputs';
import { Stage } from '~/types/Application';
import { useGetPayloadWithProvided } from '~/controllers/wizard';
import produce from 'immer';
import { merge } from 'lodash';
import AdditionalDocuments from '~/pages/ksa/application/companyQuestionnaire/components/AdditionalDocuments';

const CompanyQuestionnaire: FC = () => {
  const { t } = useTranslation('ksaApplication');
  const [form] = Form.useForm();
  const payload = useGetPayloadWithProvided();

  if (!payload) return null;

  const providedWebsiteUrl = payload?.thiqahFullInfo?.address?.general?.website;

  /*
  const hasPep = useMemo(() => {
    const payload = applicationQuery.data?.payload;
    if (payload?.authorizedRepresentative?.find((item) => item.isPep)) {
      return true;
    }
    if (payload?.shareholders?.individuals?.find((item) => item.data.isPep)) {
      return true;
    }
    if (payload?.shareholders?.beneficialOwners?.find((item) => item.data.isPep)) {
      return true;
    }
    return false;
  }, [applicationQuery.data]);

  const showPepSection = !hasPep;
    */

  return (
    <Container className="CompanyQuestionnaire">
      <Typography.Title>{t('Company Questionnaire')}</Typography.Title>
      <Typography.Paragraph className="CompanyQuestionnaire-Title">
        {t('Please share additional information about your business.')}
      </Typography.Paragraph>
      <Form
        form={form}
        payloadKey="companyQuestionnaire"
        stage={Stage.ksaApplication}
        setInitialValues={(initialValues) => {
          let result = initialValues;
          if (providedWebsiteUrl) {
            result = merge(initialValues, {
              companyQuestionnaire: {
                companyInformation: {
                  websiteUrl: providedWebsiteUrl,
                },
              },
            });
          }
          return result;
        }}
      >
        <Section formItemLast>
          <Typography.Title level={4}>{t('Company information').toUpperCase()}</Typography.Title>
          <CompanyInformationInputs />
        </Section>
        <Section formItemLast>
          <Typography.Title level={4}>{t('Expected turnover').toUpperCase()}</Typography.Title>
          <ExpectedTurnoverInputs />
        </Section>
        <Section formItemFirst>
          <Typography.Title level={4}>{t('Declaration').toUpperCase()}</Typography.Title>
          <DeclarationInputs />
        </Section>
        <AdditionalDocuments />
        <CustomFields />
      </Form>
    </Container>
  );
};

const Container = styled.div`
  h1 {
    margin-bottom: 16px;
  }
  .CompanyQuestionnaire-Title {
    margin-bottom: 56px;
  }
`;

export default CompanyQuestionnaire;
